import { render, staticRenderFns } from "./RefundDetail.vue?vue&type=template&id=3b9b5b16&scoped=true"
import script from "./RefundDetail.vue?vue&type=script&lang=js"
export * from "./RefundDetail.vue?vue&type=script&lang=js"
import style0 from "./RefundDetail.vue?vue&type=style&index=0&id=3b9b5b16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9b5b16",
  null
  
)

export default component.exports